import HomePage from "../Homepage/HomePage";
import LoggedIn from "../LoggedIn";
import Admin from "../Admin";
import Source from "../Source";
import Dashboard from "../Dashboard";
import TopMenuAndContentWrapper from "../common/TopMenuAndContentWrapper";
import DashboardHomeContent from "../Dashboard/Home/HomeContent";
import FiltersFilterContent from "../Dashboard/Filters/FilterContent";
import SettingsContent from "../Dashboard/Settings/SettingsContent";
import SettingsBrowserSourceContent from "../Dashboard/Settings/BrowserSourceContent";
import SettingsAccountSettings from "../Dashboard/Settings/AccountSettings";
import Browse from "../Dashboard/Templates/Browse";
import Selected from "../Dashboard/Templates/Selected";
import Upload from "../Dashboard/Templates/Upload";
import HelpContent from "../Dashboard/Help/HelpContent";
import ReportedImages from "../Admin/reportedImages";
import AdminDashboard from "../Admin/AdminDashboard";
import Moderation from "../Dashboard/Moderation";
import ModeratorList from "../Dashboard/Moderation/ModeratorList";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import Tests from "../Admin/Tests";

// This is just an array of logical "routes"
// that have `path` and `element` props.
// These "routes" become <Route /> components, so order matters here.
// mainTitle represents the title displayed in the main top menu bar,
// while title is used as the name for each tab in the top menu bar.

const useRoutes = () => {
    const { t } = useTranslation("menu");

    return useMemo(
        () => [
            {
                path: "/loggedIn",
                element: <LoggedIn />,
            },
            {
                path: "/admin",
                element: <Admin />,
                children: [
                    {
                        title: t("titleReports"),
                        path: "/admin/reports",
                        element: <ReportedImages />,
                    },
                    {
                        title: t("titleTests"),
                        path: "/admin/tests",
                        element: <Tests />,
                    },
                    {
                        title: t("sideMenuDashboard"),
                        path: "/admin",
                        element: <AdminDashboard />,
                    },
                ],
            },
            {
                path: "/source/*",
                element: <Source />,
            },
            {
                path: "/dashboard",
                element: <Dashboard />,
                children: [
                    {
                        path: "/dashboard/templates",
                        element: <TopMenuAndContentWrapper />,
                        children: [
                            {
                                mainTitle: t("sideMenuMemeTemplateLibarary"),
                                title: t("subTitleSelected"),
                                path: "/dashboard/templates/selected",
                                element: <Selected />,
                            },
                            {
                                mainTitle: t("sideMenuMemeTemplateLibarary"),
                                title: t("subTitleUpload"),
                                path: "/dashboard/templates/upload",
                                element: <Upload />,
                            },
                            {
                                mainTitle: t("sideMenuMemeTemplateLibarary"),
                                title: t("subTitleTemplates"),
                                path: "/dashboard/templates",
                                element: <Browse />,
                            },
                        ],
                    },
                    {
                        path: "/dashboard/filters",
                        element: <TopMenuAndContentWrapper />,
                        children: [
                            {
                                mainTitle: t("titleFilters"),
                                title: "",
                                path: "/dashboard/filters",
                                element: <FiltersFilterContent />,
                            },
                        ],
                    },
                    {
                        path: "/dashboard/moderation",
                        element: <Moderation />,
                        children: [
                            {
                                mainTitle: t("sideMenuModeration"),
                                title: "",
                                path: "/dashboard/moderation",
                                element: <ModeratorList />,
                            },
                        ],
                    },
                    {
                        path: "/dashboard/settings",
                        element: <TopMenuAndContentWrapper />,
                        children: [
                            {
                                mainTitle: t("sideMenuSettings"),
                                title: t("titleAccountSettings"),
                                path: "/dashboard/settings/accountsettings",
                                element: <SettingsAccountSettings />,
                            },
                            {
                                mainTitle: t("sideMenuSettings"),
                                title: t("titleBrowserSource"),
                                path: "/dashboard/settings/browsersource",
                                element: <SettingsBrowserSourceContent />,
                            },
                            {
                                mainTitle: t("sideMenuSettings"),
                                title: t("titleGeneralSettings"),
                                path: "/dashboard/settings",
                                element: <SettingsContent />,
                            },
                        ],
                    },
                    {
                        path: "/dashboard/help",
                        element: <TopMenuAndContentWrapper />,
                        children: [
                            {
                                mainTitle: t("sideMenuHelp"),
                                title: "",
                                path: "/dashboard/help",
                                element: <HelpContent />,
                            },
                        ],
                    },
                    {
                        mainTitle: t("sideMenuDashboard"),
                        path: "/dashboard",
                        element: <DashboardHomeContent />,
                    },
                ],
            },
            {
                path: "/",
                element: <HomePage />,
            },
        ],
        [t],
    );
};

export default useRoutes;
